var map = {
	"./brands.json": [
		967,
		749
	],
	"./custom-icons.json": [
		968,
		750
	],
	"./full-color.json": [
		969,
		751
	],
	"./light.json": [
		970,
		752
	],
	"./solid.json": [
		971,
		753
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 955;
module.exports = webpackAsyncContext;